import { ReportsActionUnion, ReportActionTypes } from './actions';
import { ReportsState, ReportsTabs } from './state';

export const reportsDefaultState: ReportsState = {
  activeTab: ReportsTabs.ManagersOverview
};

export function reportsReducer(
  state: ReportsState = reportsDefaultState,
  action: ReportsActionUnion
) {
  switch (action && action.type) {
    case ReportActionTypes.SetActiveTab:
      return {
        ...state,
        activeTab: action.payload
      };

    default:
      return state;
  }
}

export const getActiveTabState = (state: ReportsState) => state.activeTab;
